<template>
    <div class="flex items-center justify-between">
        <span class="flex-grow flex flex-col text-right mr-3">
            <span class="text-sm font-medium text-gray-200">{{label}}</span>
        </span>
        <button type="button" 
            class="relative inline-flex flex-shrink-0 h-6 w-11 border-2 border-transparent rounded-full cursor-pointer transition-colors ease-in-out duration-200 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500" 
            role="switch"
            :class="value ? 'bg-violet-400': 'bg-gray-200'"
            @click="$emit('input', !value)">
            <span class="sr-only">Use setting</span>
            <span aria-hidden="true" class="pointer-events-none inline-block h-5 w-5 rounded-full bg-white shadow transform ring-0 transition ease-in-out duration-200"
                :class="value ? 'translate-x-5': 'translate-x-0'"></span>
        </button>
    </div>
</template>
<script>
export default {
    props: ['value', 'label'],
}
</script>